/**
 * Custom Next.js Image Loader for Sanity CDN
 *
 * Translates next/image's {src, width, quality} to Sanity CDN URL params.
 * Configured in next.config.ts as the default image loader.
 *
 * @see https://nextjs.org/docs/app/api-reference/next-config-js/images#loaderfile
 */

interface ImageLoaderParams {
  src: string
  width: number
  quality?: number
}

export default function sanityImageLoader({ src, width, quality }: ImageLoaderParams): string {
  // If the src is already a full Sanity CDN URL with transforms, append width/quality params
  const url = new URL(src)

  url.searchParams.set('w', String(width))
  url.searchParams.set('q', String(quality ?? 80))
  url.searchParams.set('auto', 'format')
  url.searchParams.set('fit', 'max')

  return url.toString()
}
